/* This service only needs to be imported, nothing is exported. It search for
 * some element with attribute `data-play-count-increment-url` and if found it
 * sets events on 'video' elements to incremtnent play count via ajax. */

 /* Requires events.service */
import eventsService from '../services/events.service';

const contentEl = document.querySelector('[data-ajax-play-count-increment-url]');

if (contentEl)
{
  /* play count increment url */
  const playCountIncrementUrl = contentEl.dataset.ajaxPlayCountIncrementUrl;

  /* Remember if alredy fired that id */
  let firedPlayCountAudioIds = [];

  /* Set events for audio */
  eventsService.addListener(eventsService.AUDIO_PLAYER_START, (event) => {
    const audioWrapperEl = event.target.parentElement;
    if (audioWrapperEl.dataset.audioId) {
      playCountIncrement(audioWrapperEl.dataset.audioId);
    }
  });

  /* Function et events for video and call it for initialc content */
  const setPlayCountIncrementEventForVideos = () => {
    const videoEls = document.querySelectorAll('video');
    for (const videoEl of videoEls) {
      if (!videoEl.dataset.play_event_set) {
        console.log('setPlayCountIncrementEventForVideos: set event for video', videoEl);
        videoEl.dataset.play_event_set = true;
        videoEl.addEventListener('play', (event) => {
          const audioId = event.target.dataset.audioId;
          playCountIncrement(audioId);
        });
      }
    }
  }
  setPlayCountIncrementEventForVideos();

  /* Function to increment play count */
  const playCountIncrement = (audioId) => {
    if (audioId && undefined === firedPlayCountAudioIds
        .find(audioIdIt => audioIdIt == audioId))
    {
      firedPlayCountAudioIds.push(audioId);
      axios.post(playCountIncrementUrl, {
          audio_id: audioId,
        })
        .then((response) => {})
        .catch((error) => {});
      }
  }

  /* Declare global function: */

  /* Cll antytime you want to increment play count */
  window.dashboardPlayCountIncrement = playCountIncrement;

  /* Call anytime new videos may be added to the DOM */
  window.dashboardSetPlayCountIncrementEventForVideos = setPlayCountIncrementEventForVideos;

}
